import { defineComponent as _defineComponent } from 'vue'
import { computed, ref } from "vue";

import ValidatedIntInput from "@/components/validated_input/ValidatedIntInput.vue";
import InputErrors from "@/components/validated_input/InputErrors.vue";
import { make_min_validator } from "@/new_validators";
import {
  use_validation,
  ValidatorFuncType,
  ParserFuncType,
} from "@/composables/use_validation";

type NumberPair = {
  first: number;
  second: number;
};

type EmitTypes = {
  (e: "update:is_valid", value: boolean): void;
  (e: "input", value: number): void;
};

export default /*#__PURE__*/_defineComponent({
  __name: 'PairedInputs',
  emits: ["update:is_valid", "input"],
  setup(__props, { emit }: { emit: ({
  (e: "update:is_valid", value: boolean): void;
  (e: "input", value: number): void;
}), expose: any, slots: any, attrs: any }) {

const first = ref<number>(1);
const second = ref<number>(1);
const pair = computed<NumberPair>(() => ({
  first: first.value,
  second: second.value,
}));



const parser: ParserFuncType<NumberPair, number> = (value: NumberPair) => {
  return {
    is_valid: true,
    output: value.first + value.second,
  };
};

const is_div_by_4_validator: ValidatorFuncType<number> = (value: number) => {
  if (value % 4 === 0) {
    return { is_valid: true };
  } else {
    return {
      is_valid: false,
      error_msg: "The sum of the operands must be divisble by 4",
    };
  }
};

const { errors } = use_validation<NumberPair, number>({
  input: pair,
  validators: [is_div_by_4_validator],
  emit,
  parser,
});

return { __sfc: true,first, second, pair, emit, parser, is_div_by_4_validator, errors, ValidatedIntInput, InputErrors, make_min_validator }
}

})